<script lang="ts">
	import type { Segment } from 'Segments';

	export let row: Segment;
</script>

<div class="trunc-parent">
	<div class="trunc-child mdc-typography--body2" title={row.id}>
		{row.id}
	</div>
</div>

<style>
	.trunc-parent {
		display: flex;
		min-width: 20px;
		width: 100%;
		max-width: 5vw;
	}

	.trunc-child {
		min-width: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>
